import styles from "./Menu.module.css";
import React, { useEffect, useState } from "react";
import Button from "../components/Button";
import { flashAlert, popup, popupClose } from "../global_js";
import CreateMenuItemModal from "../modals/CreateMenuItemModal";
import AddSubmenuItemModal from "../modals/AddSubmenuItemModal";
import EditSubmenuItemModal from "../modals/EditSubmenuItemModal";

function Menu() {
  const location = JSON.parse(localStorage.getItem("userLogin")).location;
  const restLocations = JSON.parse(sessionStorage.getItem("locations"));
  const [userLocation, setUserLocation] = useState(location == 0 ? restLocations[0].idLocation : location);
  const [menuItems, setMenuItems] = useState([]);
  const [filteredMenuItems, setFilteredMenuItems] = useState([]);
  const [showInactive, setShowInactive] = useState(false);
  const [menuCategories, setMenuCategories] = useState([]);
  const [searchParam, setSearchParam] = useState("");
  const [resetMenuItems, setResetMenuItems] = useState([]);
  const [rowInEdit, setRowInEdit] = useState("");
  const [editModal, setEditModal] = useState({ show: false, props: null });

  //Get Menu Items
  const getMenu = async () => {
    //Deactive edit mode if selected
    if (rowInEdit) {
      deactivateInput(rowInEdit);
    }
    const res = await fetch(`/api/editmenu?loc=${userLocation}&show=${showInactive}`);
    const data = await res.json();
    setMenuItems(data);
  };

  //GetMenuCategories
  useEffect(() => {
    getCategories();
  }, []);

  const getCategories = async () => {
    const res = await fetch(`/api/categories`);
    const data = await res.json();
    setMenuCategories(data);
  };

  // Set each menu row into edit mode
  const rowEditMode = (row) => {
    setResetMenuItems(filteredMenuItems);
    setRowInEdit(row);
    const ctlInputs = document.querySelectorAll(`#data${row} input`);
    const ctlSelects = document.querySelectorAll(`#data${row} select`);
    ctlInputs.forEach((ctl) => {
      ctl.removeAttribute("readOnly");
      ctl.classList.add(styles.editMode);
    });
    ctlSelects.forEach((ctl) => {
      ctl.removeAttribute("disabled");
      ctl.classList.add(styles.editMode);
    });
    document.getElementById(`group${row}`).classList.add(styles.editing);
    document.getElementById(`button${row}`).classList.add(styles.remove);
  };

  //Deactivate Edit Mode and reset menu items on save or not save.
  const deactivateInput = (row, isSave = 0) => {
    setRowInEdit("");
    if (!isSave) {
      setMenuItems(resetMenuItems);
    }
    const ctlInputs = document.querySelectorAll(`#data${row} input`);
    const ctlSelects = document.querySelectorAll(`#data${row} select`);
    ctlInputs.forEach((ctl) => {
      ctl.setAttribute("readOnly", true);
      ctl.classList.remove(styles.editMode);
      ctl.value = ctl.defaultValue;
    });
    ctlSelects.forEach((ctl) => {
      ctl.setAttribute("disabled", true);
      ctl.classList.remove(styles.editMode);
    });
    document.getElementById(`group${row}`).classList.remove(styles.editing);
    document.getElementById(`button${row}`).classList.remove(styles.remove);
  };

  //Function to Update Menu Name during Edit
  const updateMenuItemName = (row, el) => {
    const item = filteredMenuItems[row];
    const newItems = [...filteredMenuItems];
    newItems[row] = { ...item, Item: el.value };
    setMenuItems(newItems);
  };

  // Function to update the menu item price
  const updateMenuItemPrice = (row, el) => {
    console.log(el);
    if (isNaN(el.value)) {
      el.setCustomValidity("Must be a number");
      return;
    }
    const item = filteredMenuItems[row];
    const newItems = [...filteredMenuItems];
    newItems[row] = { ...item, Price: el.value };
    setMenuItems(newItems);
  };

  //Function to update the selection count
  const updateMenuItemSelectionCount = (row, el) => {
    if (isNaN(Number(el.value))) {
      el.setCustomValidity("Must be a number");
      return;
    }
    const item = menuItems[row];
    const newItems = [...menuItems];
    newItems[row] = { ...item, selectionCount: Number(el.value) };
    setMenuItems(newItems);
  };

  //Function to manage the state of the different menu selects
  const updateMenuItemSelect = (row, el) => {
    const item = filteredMenuItems[row];
    const newItems = [...filteredMenuItems];

    switch (el.target.name) {
      case "isPricePer":
        newItems[row] = { ...item, isPricePer: el.target.value === "false" ? false : true };
        break;
      case "hasSelections":
        newItems[row] = { ...item, hasSelections: el.target.value === "false" ? false : true };
        break;
      case "includeInMenu":
        newItems[row] = { ...item, includeInMenu: el.target.value === "false" ? false : true };
        break;
      case "Active":
        newItems[row] = { ...item, Active: el.target.value === "false" ? false : true };
        break;
    }
    setFilteredMenuItems(newItems);
  };

  //Do the actual save of the menu item
  const saveMenuItem = async (row) => {
    const submitData = filteredMenuItems[row];
    await fetch("/api/editmenu", {
      method: "put",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(submitData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.code) {
          flashAlert("The menu item did not save. Error: " + data.code, "error");
        } else {
          flashAlert("Menu Items Saved", "success");
          deactivateInput(rowInEdit, 1);
          getMenu();
        }
      });
  };

  const editSubmenu = (item) => {
    setEditModal({ show: true, props: item });
  };

  //update menu based on location or inactive status
  useEffect(() => {
    getMenu();
  }, [showInactive, userLocation]);

  //Function to filter or refilter based on search parameter
  useEffect(() => {
    if (searchParam) {
      const searchedItems = menuItems.filter((sel) => sel.Item.toLowerCase().includes(searchParam.toLocaleLowerCase()));
      setFilteredMenuItems(searchedItems);
    } else {
      setFilteredMenuItems(menuItems);
    }
  }, [searchParam, menuItems]);

  return (
    <section className={styles.menuItemList}>
      <h2 className={styles.pageTitle}>Menu Items - {restLocations.filter((rest) => rest.idLocation == userLocation)[0].Description}</h2>
      <div className={styles.menuPrimaryHeader}>
        {location == 0 && (
          <div className={`${styles.inlineDiv} ${styles.radioButton}`}>
            <label style={{ display: "block" }}>Select Location</label>
            {restLocations.map((loc, index) => {
              return (
                <div className={styles.radioDiv}>
                  <input
                    type="radio"
                    name="restaurant"
                    id={loc.idLocation}
                    className={styles.radioSelection}
                    value={loc.idLocation}
                    checked={userLocation == loc.idLocation ? true : false}
                    onChange={(e) => setUserLocation(e.target.value)}
                    key={loc.idLocation}
                  />
                  <label htmlFor={loc.idLocation}>{loc.Description}</label>
                </div>
              );
            })}
          </div>
        )}
        <div className={styles.checkboxDiv}>
          <input
            type="checkbox"
            id="showInactive"
            className={styles.showInactive}
            checked={showInactive}
            onChange={() => setShowInactive(!showInactive)}
          />
          <span>Show inactive menu items</span>
        </div>
        <CreateMenuItemModal menuCategories={menuCategories} location={userLocation} getMenu={getMenu} menuItems={menuItems} />
      </div>
      <div id="menuSearchDiv" className={styles.menuSearch}>
        <label htmlFor="">Find menu item:</label>
        <input type="text" name="" id="" value={searchParam} placeholder="Search" onChange={(e) => setSearchParam(e.target.value)} />
        {searchParam && <i className={`fa-solid fa-xmark ${styles.closeIcon}`} onClick={() => setSearchParam("")}></i>}
      </div>
      <hr />
      <div className={styles.menuTableDiv}>
        {filteredMenuItems.length > 0 && (
          <table className={styles.menuItemListTable}>
            <thead>
              <tr>
                <th>Menu Item</th>
                <th>Type</th>
                <th>Price</th>
                <th>Per Person?</th>
                <th>Has Selections</th>
                <th>Selection Count</th>
                <th></th>
                <th>Include in menu</th>
                <th>Active</th>
                <th></th>
              </tr>
            </thead>
            {/* {mapMenuRows()} */}
            <tbody>
              {filteredMenuItems.map((item, index) => {
                return (
                  <tr id={`dataRow-${item.idBanquetMenu}`}>
                    <td>
                      <input
                        type="text"
                        value={item.Item}
                        className={`${styles.menuInput}`}
                        onChange={(e) => updateMenuItemName(index, e.target)}
                        readOnly
                      />
                    </td>
                    <td>{item.descriptions}</td>
                    <td>
                      <input
                        type="text"
                        value={item.Price}
                        className={`${styles.menuInput}`}
                        onChange={(e) => updateMenuItemPrice(index, e.target)}
                        readOnly
                      />
                    </td>
                    <td>
                      <select
                        className={styles.menuSelect}
                        value={item.isPricePer === null ? false : item.isPricePer}
                        name="isPricePer"
                        onChange={(e) => updateMenuItemSelect(index, e)}
                        disabled
                      >
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                      </select>
                    </td>
                    <td>
                      <select
                        className={styles.menuSelect}
                        value={item.hasSelections === null ? false : item.hasSelections}
                        name="hasSelections"
                        onChange={(e) => updateMenuItemSelect(index, e)}
                        disabled
                      >
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                      </select>
                    </td>
                    <td>
                      {item.hasSelections && (
                        <input
                          type="text"
                          value={item.selectionCount === null ? 0 : item.selectionCount}
                          className={`${styles.menuInput}`}
                          onChange={(e) => updateMenuItemSelectionCount(index, e.target)}
                          readOnly
                        />
                      )}
                    </td>
                    <td>
                      {!item.hasSelections ? (
                        ""
                      ) : (
                        <Button type="secondary" onClick={() => editSubmenu(item)}>{`Edit (${item.selectionCount})`}</Button>
                      )}
                    </td>
                    <td>
                      <select
                        className={styles.menuSelect}
                        value={item.includeInMenu === null ? false : item.includeInMenu}
                        name="includeInMenu"
                        onChange={(e) => updateMenuItemSelect(index, e)}
                        disabled
                      >
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                      </select>
                    </td>
                    <td>
                      <select
                        className={styles.menuSelect}
                        value={item.Active}
                        name="Active"
                        onChange={(e) => updateMenuItemSelect(index, e)}
                        disabled
                      >
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                      </select>
                    </td>
                    <td>
                      <Button
                        type="pOutline"
                        id={`buttonRow-${item.idBanquetMenu}`}
                        onClick={() => {
                          rowEditMode(`Row-${item.idBanquetMenu}`);
                        }}
                      >
                        Edit
                      </Button>
                      <div id={`groupRow-${item.idBanquetMenu}`} className={styles.saveButtonGroup}>
                        <i className={`fa-solid fa-floppy-disk ${styles.saveIcon}`} onClick={() => saveMenuItem(index)}></i>
                        <i
                          className={`fa-solid fa-xmark ${styles.closeIcon}`}
                          onClick={() => {
                            //setEventData({ ...eventData, Deposit: tempInputValue });
                            deactivateInput(`Row-${item.idBanquetMenu}`);
                          }}
                        ></i>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td></td>
              </tr>
            </tfoot>
          </table>
        )}
      </div>
      <submenu id="submenuholder">
        {editModal.show && editModal.props && (
          <EditSubmenuItemModal props={editModal.props} setEditModal={setEditModal} menuItems={menuItems} getMenu={getMenu} />
        )}
      </submenu>
    </section>
  );
}

export default Menu;
